const initialState = {
  list: [],
  total: "",
  searchKey: "",
};

const ManageFlasCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "MANAGE_ALL_FLASH_CARD_RESPONSE":
      return {
        ...state,
        list: [...action.data.list],
        total: action.data.total,
      };

    default:
      return state;
  }
};

export default ManageFlasCardReducer;
